module.exports = __webpack_public_path__ + "static/party-room-91a4331d9f28ba75a6752d4dd5fa6c67.jpeg";